export enum FinancialReportType {
  FINANCIAL_INCOME_AND_COSTS = 'FINANCIAL_INCOME_AND_COSTS',
  FINANCIAL_MONTHLY = 'FINANCIAL_MONTHLY',
  FINANCIAL_ANNUAL = 'FINANCIAL_ANNUAL',
  FINANCIAL_MONTHLY_ACHIEVEMENTS = 'FINANCIAL_MONTHLY_ACHIEVEMENTS',
}
